<template>
  <div>
    <div class="table-control-bar col-md-12">
      <b-table :fields="get_fields" responsive="" :items="get_data">
        <template v-slot:cell(actions)="data">
          <div class="text-right d-flex flex-nowrap">
            <button
              class="btn px-1 btn-sm btn-link text-info"
              @click="edit(data.index)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button
              class="btn px-1 btn-sm btn-link text-danger"
              @click="remove(data.index)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </template>
      </b-table>
      <button class="btn btn-sm btn-success mb-4" @click="add">
        {{ $t("message.add") }}
      </button>
      <b-modal
        :id="'edit-row-modal' + id"
        :title="$t('message.contracts.sad_g44_modal')"
        size="sm"
      >
        <form-sad-subitems
          :gtd="editable_row"
          :current_fields="[{ items: options.options.columns }]"
        ></form-sad-subitems>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="default"
              size="sm"
              class="float-right"
              @click="$bvModal.hide('edit-row-modal' + id)"
            >
              {{ $t("message.cancel") }}
            </b-button>
            <b-button
              variant="success"
              size="sm"
              class="float-right"
              @click="$bvModal.hide('edit-row-modal' + id)"
            >
              {{ $t("message.save") }}
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
export default {
  name: "sad-table-field",
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
    classes: String,
    id: String,
    product: {
      type: Object,
      default: () => {
        return {};
      },
    },
    gtd: {
      type: Object,
      default: () => {
        return {};
      },
    },
    errors: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      editable_row: {},
    };
  },
  methods: {
    add() {
      if (this.options.options.is_in_product) {
        this.product[this.options.model].push(this.get_fields_wrap);
        this.editable_row =
          this.product[this.options.model][
            this.product[this.options.model].length - 1
          ];
      } else {
        this.gtd[this.options.model].push(this.get_fields_wrap);
        this.editable_row =
          this.gtd[this.options.model][this.gtd[this.options.model].length - 1];
      }
      this.$bvModal.show("edit-row-modal" + this.id);
    },
    remove(index) {
      if (this.options.options.is_in_product) {
        this.product[this.options.model].splice(index, 1);
      } else {
        this.gtd[this.options.model].splice(index, 1);
      }
    },
    edit(index) {
      if (this.options.options.is_in_product) {
        this.editable_row = this.product[this.options.model][index];
      } else {
        this.editable_row = this.gtd[this.options.model][index];
      }
      this.$bvModal.show("edit-row-modal" + this.id);
    },
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    get_fields_wrap() {
      let fields = {};
      this.options.options.columns.forEach((column) => {
        if (column.type != "v-select") {
          if (column.options.autoload) {
            const regex = new RegExp("\\((.*)\\)=>{(.*)}", "gms");
            let m;
            m = regex.exec(column.options.autoload);
            if (m.length == 3) {
              let args = m[1].split(",").map((item) => {
                return item.trim();
              });
              let code = m[2].trim();
              let func = Function(...args, code);
              fields[column.model] = func(
                column,
                this.product[this.options.model].length,
                this.product,
              );
            }
          } else fields[column.model] = "";
        } else {
          fields[column.model] = { value: "" };
        }
      });
      return fields;
    },
    get_fields() {
      let fields = [];
      this.options.options.columns.forEach((column) => {
        if (column.type == "v-select")
          fields.push({
            key: column.model,
            label: this.$t(column.label),
            formatter: (value) => {
              return value.display_text;
            },
          });
        else if (column.type == "cleave")
          fields.push({
            key: column.model,
            label: this.$t(column.label),
            formatter: (value) => {
              return new Intl.NumberFormat(this.locale).format(value);
            },
          });
        else
          fields.push({
            key: column.model,
            label: this.$t(column.label),
          });
      });
      fields.push({
        key: "actions",
        label: "",
      });
      return fields;
    },
    get_data() {
      let data = [];
      if (this.options.options.is_in_product) {
        this.product[this.options.model].forEach((row) => {
          data.push(row);
        });
      } else {
        this.gtd[this.options.model].forEach((row) => {
          data.push(row);
        });
      }
      return data;
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 992px) {
  .table-control-bar {
    max-width: calc(800px - 3.4rem);
  }
}
@media screen and (max-width: 576px) {
  .table-control-bar {
    max-width: calc(360px - 3.4rem);
  }
}
</style>
